module.exports = __webpack_public_path__ + "img/ardor_tab.c2ab6d1.webp";